// src/store.js

import {Hub} from 'aws-amplify/utils';

import {combineReducers, configureStore} from '@reduxjs/toolkit';
import authSlice, {
  refreshAccessTokenCache,
  resetAuthState,
} from './slices/authSlice';
import sessionSlice from './slices/sessionSlice';
import projectScopeSlice from './slices/projectScopeSlice';

import {
  FLUSH,
  PAUSE,
  PERSIST,
  PURGE,
  REGISTER,
  REHYDRATE,
  persistReducer,
  persistStore,
} from 'redux-persist';
import type {PersistConfig} from 'redux-persist';
import storage from 'redux-persist/lib/storage'; // defaults to localStorage for web
import {emptySplitApi} from './api';
import interfaceSlice from './slices/interfaceSlice';
import treeBrowserSlice from './slices/treeBrowserSlice';
import {clearLoginRouting} from 'src/app/security/authentication/configureAmplify';
import {setProjectScopeId} from 'src/shared/utils/projectScopeHeader';
export {purgeInstanceScopedState} from './slices/instanceSwitchActions';
import userSlice from './slices/userSlice';
import vendorSlice from './slices/vendorSlice';

const rootReducer = combineReducers({
  auth: authSlice,
  session: sessionSlice,
  projectScope: projectScopeSlice,
  interface: interfaceSlice,
  treeBrowser: treeBrowserSlice,
  vendor: vendorSlice,
  user: userSlice,
  [emptySplitApi.reducerPath]: emptySplitApi.reducer,
});

type RootReducerState = ReturnType<typeof rootReducer>;

// projectScope has its own nested persist (sessionStorage); the root persists
// only the session slice to localStorage.
const persistConfig: PersistConfig<RootReducerState> = {
  key: 'root',
  storage,
  whitelist: ['session'],
};

const persistedReducer = persistReducer(persistConfig, rootReducer);

export const store = configureStore({
  reducer: persistedReducer,
  middleware: getDefaultMiddleware =>
    getDefaultMiddleware({
      serializableCheck: {
        ignoredActions: [FLUSH, REHYDRATE, PAUSE, PERSIST, PURGE, REGISTER],
      },
    }).concat(emptySplitApi.middleware),
});

// Sync the axios X-Project-Id holder from persisted scope; fires after REHYDRATE
// too, so the header is correct on the first request after reload.
store.subscribe(() => {
  setProjectScopeId(store.getState().projectScope.scope?.id ?? null);
});

export const persistor = persistStore(store);

export type RootState = ReturnType<typeof store.getState>;

export type AppDispatch = typeof store.dispatch;

Hub.listen('auth', ({payload}) => {
  switch (payload.event) {
    case 'signedIn':
      console.log('user have been signedIn successfully.');
      void store.dispatch(refreshAccessTokenCache());
      break;

    case 'signedOut':
      console.log('user have been signedOut successfully.');

      break;

    case 'tokenRefresh':
      console.log('auth tokens have been refreshed.');
      void store.dispatch(refreshAccessTokenCache());

      break;

    case 'tokenRefresh_failure':
      console.log('failure while refreshing auth tokens.');
      store.dispatch(resetAuthState());
      clearLoginRouting();

      break;

    case 'signInWithRedirect':
      console.log('signInWithRedirect API has successfully been resolved.');

      break;

    case 'signInWithRedirect_failure':
      console.log('failure while trying to resolve signInWithRedirect API.');

      break;
  }
});
